////////////////////
// Template

import { format_price } from "../../utils/cart-utils";
import { loadImage } from "../../utils/image";

const IMAGE_WIDTH = 114;
const IMAGE_HEIGHT = 114;

////////////////////
const template = /*html*/ `
    <li class='c-cart-item'>
        <div class="c-cart-item_description">
            <figure class="c-figure c-cart-item_visual">
                <div class="c-figure_inner || o-lazy">
                    <img
                        class="c-figure_image || o-lazy_image -lazy-loaded"
                        :src="currentImageObj.url"
                        :alt="productTitle"
                        width="114"
                        height="114"
                    >
                </div>
            </figure>

            <div class="c-cart-item_content">
                <div class="c-cart-item_content_top">
                    <h3 class="c-text">{{ productTitle }}</h3>
                    <p v-if="currentOptions" class="c-cart-item_options || c-text">{{ currentOptions }}</p>
                    <p v-if="currentProperties" v-for="property in currentProperties" class="c-cart-item_options || c-text">{{ property?.key }} : {{ property?.value }}</p>
                </div>
                <div class="c-cart-item_content_bottom">
                    <div class="c-cart-item_form">
                        <quantity-input
                            ref="quantityInput"
                            class="-cart"
                            :default-value="quantity"
                            :max="inventoryQuantity"
                            :force-default-value="true"
                            @onIncrease="onIncreaseQuantity"
                            @onDecrease="onDecreaseQuantity"
                            @onDelete="onDeleteItem"
                        />

                        <button class="c-cart-item_delete || c-text" aria-label="Retirer du panier" type="button" @click="onDeleteItem">
                            <span class="c-button_label">{{ deleteLabel }}</span>
                        </button>
                    </div>

                    <p class="c-cart-item_price">
                        <span v-if="currentOriginalPrice && currentOriginalPrice > 0" class="c-cart-item_price_original || c-text">{{ currentOriginalPrice }}</span>
                        <span class="c-cart-item_price_current || c-text">{{ currentPrice }}</span>
                    </p>
                </div>
            </div>
        </div>
    </li>
`;


////////////////////
// Scripts
////////////////////
export default function VueCartItem() {

    Vue.component("cart-item", {

        template,

        props: {
            variantId: {
                type: String,
                required: true
            },
            quantity: {
                type: Number,
                required: true
            },
            inventoryQuantity: {
                type: Number,
                required: true
            },
            price: {
                type: Object,
                default: () => {}
            },
            compareAtPrice: {
                type: Object,
                default: () => {}
            },
            productTitle: {
                type: String,
                required: true
            },
            productKey: {
                type: String,
                required: true
            },
            image: {
                type: String,
                required: true
            },
            selectedOptions: {
                type: Object,
                default: () => {}
            },
            moduleInstance: {
                type: Object,
                default: () => {}
            },
            currencyIsoCode: {
                type: String,
                required: true
            },
            currencySymbol: {
                type: String,
                required: true
            },
            deleteLabel: {
                type: String,
                required: true
            },
            properties: {
                type: Object,
                default: () => {}
            }
        },

        data() {
            return {
                currentImageObj: {}
            };
        },

        computed: {
            currentPrice() {
                const value = this.price;

                if (typeof value != "number") return value;

                const formattedAmount = new Intl.NumberFormat(
                    window?.Shopify?.locale,
                    {
                        style: "currency",
                        currencyDisplay: "narrowSymbol",
                        currency: window?.Shopify?.currency?.active,
                    }
                ).format(value / 100);

                return formattedAmount;
            },
            currentOriginalPrice() {
                const value = this.compareAtPrice;

                if (typeof value != "number") return value;

                const formattedAmount = new Intl.NumberFormat(
                    window?.Shopify?.locale,
                    {
                        style: "currency",
                        currencyDisplay: "narrowSymbol",
                        currency: window?.Shopify?.currency?.active,
                    }
                ).format(value / 100);

                return formattedAmount;
            },
            currentSale() {
                return this.compareAtPrice && this.compareAtPrice ? `-${100 - Math.round(this.price.amount / this.compareAtPrice.amount * 100)}%` : ''
            },
            currentOptions() {
                const options = this.selectedOptions.map((options) => {
                    return options.value.charAt(0).toUpperCase() + options.value.slice(1)
                })

                if ( options.length === 1 && options[0] != "Default Title") {
                    return options[0]
                } else if (options.length && options.length > 1) {
                    return options.join(' / ')
                } else {
                    return ''
                }
            },
            currentProperties() {
                const properties = this.properties;

                // Convert properties object to an array of objects with `key` and `value`
                return Object.keys(properties).map(key => {
                    return {
                        key: key,
                        value: properties[key]
                    };
                });
            }
        },

        mounted() {},

        methods: {
            setImage() {
                const currentSrc = this.image

                if (currentSrc) {
                    const url = this.getResizedImageUrl(currentSrc, IMAGE_WIDTH, IMAGE_HEIGHT)
                    loadImage(url).then((imageObj) => {
                        this.currentImageObj = imageObj
                    })
                }
            },

            getResizedImageUrl(imageUrl, width, height) {
                const splitUrl = imageUrl.split('.')
                const sizeExtension = `_${width}x${height}_crop_center.${splitUrl.pop()}`
                return splitUrl.join('.') + sizeExtension
            },

            onDeleteItem() {
                if(!this.productKey) {
                    return;
                }

                const formData = {
                    id: this.productKey,
                    quantity: 0,
                };

                this.moduleInstance?.changeCart(formData)
            },

            onIncreaseQuantity() {
                if(!this.productKey) {
                    return;
                }

                const formData = {
                    id: this.productKey,
                    quantity: this.quantity + 1,
                };

                this.moduleInstance?.changeCart(formData)
            },

            onDecreaseQuantity() {
                if(!this.productKey) {
                    return;
                }

                const formData = {
                    id: this.productKey,
                    quantity: this.quantity - 1,
                };

                this.moduleInstance?.changeCart(formData)
            }
        }
    });
}
